import { useQuery } from '@tanstack/react-query';
import { fetchWaiverRequest } from '../../services/waivers';
import useUser from '../global/useUser';

function useGetWaiverRequest({
  waiverRequestId,
  enabled: isEnabled = true,
}: {
  waiverRequestId?: string;
  enabled?: boolean;
} = {}) {
  const { user } = useUser();
  const enabled = isEnabled && !!waiverRequestId && !!user;

  const query = useQuery({
    queryKey: ['waiver-request', waiverRequestId],
    queryFn: async () => {
      const data = await fetchWaiverRequest({
        waiverRequestId: waiverRequestId!,
      });
      return data;
    },
    enabled,
  });

  return query;
}

export default useGetWaiverRequest;
